import React, { useEffect } from "react";
import Layout from '../components/layoutBlack';
import BackgroundImage from "../assets/images/glossary/ingredients.jpg";
import Breadcrumbs from '../components/breadcrumbs';
import { Helmet } from "react-helmet-async";
import ogImage from "../assets/images/og/molu-banner-1200x630.png";

const ingredients = [
  {
    name: "2-Deoxy-D-Ribose (2dDR)",
    purpose:
      "Supports skin and hair by helping stimulate pro-growth signaling and microcirculation support (angiogenesis). For hair, this may improve the follicle environment and support healthier growth cycles; for skin, it may support repair-related processes that benefit overall skin vitality."
  },
  {
    name: "2-Phenoxyethanol",
    purpose:
      "A broad-spectrum preservative that helps keep the formula stable and safe over time for both scalp and facial skin use when formulated correctly."
  },
  {
    name: "Angiogenesis",
    purpose:
      "The formation of new blood vessels. In skin and scalp care, better microcirculation support can improve nutrient/oxygen delivery to hair follicles and support healthier-looking skin."
  },
  {
    name: "Chelating Agent (Chelate)",
    purpose:
      "Binds trace metal ions that can destabilize formulas or degrade actives. This helps protect sensitive ingredients (like vitamin C derivatives and peptides) and improves overall product stability for skin/scalp."
  },
  {
    name: "Citric Acid",
    purpose:
      "Adjusts pH to a skin/scalp-friendly range for comfort and barrier support. Also helps maintain formula stability and can help keep certain actives performing consistently."
  },
  {
    name: "GHK-Cu (Copper Tripeptide-1)",
    purpose:
      "A well-known skin and hair peptide complex. For skin, supports a healthier appearance by promoting collagen-supportive signaling and improving the look of firmness and texture. For hair/scalp, may support follicle environment signaling and overall scalp quality that helps maintain healthy growth cycles."
  },
  {
    name: "AHK-Cu (Copper Peptide, AHK-Copper Tripeptide)",
    purpose:
      "A copper peptide often used alongside GHK-Cu. For skin, supports a smoother, more resilient look by encouraging healthy renewal signals and helping reduce the appearance of fine lines and uneven texture. For hair/scalp, may support scalp conditioning and follicle-supportive signaling that complements other growth-focused actives."
  },
  {
    name: "Niacinamide (Vitamin B3)",
    purpose:
      "A multitasker for skin. For skin, helps strengthen the barrier, improve the look of pores and uneven tone, and reduce the appearance of redness."
  },
  {
    name: "Pterostilbene",
    purpose:
      "A potent antioxidant (related to resveratrol) that helps defend skin from oxidative stress. For aging skin, it supports a firmer, smoother-looking complexion by helping protect collagen and elastin from daily stressors and by supporting healthy-looking elasticity, texture, and the appearance of fine lines. It may also promote a brighter, more even-looking tone."
  },
  {
    name: "Magnesium Ascorbyl Phosphate (MAP)",
    purpose:
      "A stable vitamin C derivative. For skin, supports brighter tone and collagen support for firmer-looking skin; for scalp/hair, provides antioxidant protection that may help reduce oxidative stress around follicles."
  },
  {
    name: "Oxidative Stress",
    purpose:
      "An excess of free-radical activity that can contribute to visible aging in skin and a less-ideal scalp environment for hair. Antioxidants in the formula help counter this."
  },
  {
    name: "Propylene Glycol",
    purpose:
      "Humectant/solvent that helps retain moisture and improve how evenly actives distribute on skin/scalp, which can enhance perceived performance and feel."
  },
  {
    name: "Sodium Alginate",
    purpose:
      "A natural gelling/thickening agent that improves slip and spreadability. Helps keep actives evenly suspended and supports consistent application on scalp or skin."
  },
  {
    name: "Sodium Gluconate",
    purpose:
      "A gentle chelator that improves stability and helps protect actives from metal-catalyzed degradation, supporting consistent results for skin and scalp."
  },
  {
    name: "Sodium Lactate & Pyruvate Complex",
    purpose:
      "Hydration + bioenergetic support. Sodium lactate boosts moisture and supports barrier feel, while pyruvate relates to cellular energy pathways—often positioned as supportive for a healthier scalp environment."
  }
];


const Glossary = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Layout>
        <Helmet prioritizeSeoTags>
          {/* Basic SEO */}
          <title>Best Copper Peptides for Hair Growth | Molu Hair Growth Serum</title>
          <meta
            name="description"
            content="Boost hair strength with Molu Hair Growth’s peptide serum — the best copper peptides for faster, thicker hair."
          />
          <meta
            name="keywords"
            content="best copper peptides for hair growth, peptide serum"
          />
          <link
            rel="canonical"
            href={(typeof window !== "undefined" ? window.location.origin : "https://example.com") + "/"}
          />

          {/* Open Graph */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Best Copper Peptides for Hair Growth | Molu Hair Growth Serum" />
          <meta property="og:description" content="Boost hair strength with Molu Hair Growth’s peptide serum — the best copper peptides for faster, thicker hair." />
          <meta property="og:image" content={ogImage} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:url" content={(typeof window !== "undefined" ? window.location.href : "")} />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Best Copper Peptides for Hair Growth | Molu Hair Growth Serum" />
          <meta name="twitter:description" content="Boost hair strength with Molu Hair Growth’s peptide serum — the best copper peptides for faster, thicker hair." />
          <meta name="twitter:image" content={ogImage} />
        </Helmet>
        {/* <section
          className="bg-img1 txt-center p-lr-15 p-tb-92"
                style={{ backgroundImage: `url(${BackgroundImage})` }}
        >
          <h2 className="ltext-105 cl0 txt-center">Ingredient Glossary</h2>
        </section> */}

        <div className="container  p-t-80 p-b-10">
          <Breadcrumbs />
        </div>
        <div className="container">
          <section className="p-t-40 p-b-140">
            <div className="row">
              {ingredients.map((item, index) => (
                <div key={index} className="col-md-6 col-lg-4 p-b-30">
                  <div className="bor16 p-4 h-full shadow-sm">
                    <h4 className="mtext-108 cl2 p-b-12">{item.name}</h4>
                    <p className="stext-113 cl6">{item.purpose}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </Layout>
    </div>
  );
};

export default Glossary;